// Mapa centralizado de nomes de cores → hex, com suporte extenso a nomes em português
// e variações sem acento, plural, com hífen, etc.

const RAW_MAP = {
  // Básicas
  'branco': '#ffffff', 'preto': '#111111', 'cinza': '#9ca3af', 'cinzento': '#9ca3af',
  'vermelho': '#ef4444', 'vermelha': '#ef4444',
  'azul': '#3b82f6', 'azul marinho': '#1e3a8a', 'azul bebe': '#bfdbfe', 'azul claro': '#60a5fa', 'azul escuro': '#1e40af', 'azul royal': '#1d4ed8', 'azul turquesa': '#06b6d4',
  'verde': '#22c55e', 'verde claro': '#86efac', 'verde escuro': '#166534', 'verde agua': '#5eead4', 'verde limao': '#a3e635', 'verde militar': '#4d5d23', 'verde musgo': '#4d5d23', 'verde bandeira': '#166534', 'verde oliva': '#556b2f', 'verde menta': '#98ff98',
  'amarelo': '#eab308', 'amarela': '#eab308', 'amarelo claro': '#fef08a', 'amarelo ouro': '#ffd700', 'amarelo canario': '#ffef00',
  'rosa': '#ec4899', 'rosa claro': '#fbcfe8', 'rosa bebe': '#ffd1dc', 'rosa pink': '#ff1493', 'pink': '#ff1493', 'rosa choque': '#ff007f',
  'roxo': '#8b5cf6', 'roxa': '#8b5cf6', 'lilas': '#c084fc', 'lilás': '#c084fc', 'lavanda': '#e6e6fa',
  'laranja': '#f97316', 'laranja claro': '#fdba74', 'laranja escuro': '#c2410c',
  'marrom': '#92400e', 'marrom claro': '#c89666', 'marrom escuro': '#5c2e00', 'chocolate': '#7b3f00', 'cafe': '#6f4e37',
  'dourado': '#d4a017', 'dourada': '#d4a017', 'ouro': '#ffd700',
  'prata': '#c0c0c0', 'prateado': '#c0c0c0',
  'bege': '#d2b48c', 'creme': '#fffdd0', 'marfim': '#fffff0', 'perola': '#f0ead6',
  'vinho': '#722f37', 'bordo': '#8b0000', 'bordô': '#8b0000', 'terracota': '#e2725b',
  'turquesa': '#06b6d4', 'ciano': '#00ffff', 'coral': '#ff7f50', 'salmao': '#fa8072', 'salmão': '#fa8072',
  'nude': '#e8c39e', 'caramelo': '#c68e17', 'mostarda': '#ffdb58', 'pessego': '#ffcba4', 'pêssego': '#ffcba4',
  'transparente': 'transparent',
  // Metálicos / Glitter
  'holografico': 'linear-gradient(45deg, #ff0080, #ffff00, #00ffff, #ff00ff)', 'holográfico': 'linear-gradient(45deg, #ff0080, #ffff00, #00ffff, #ff00ff)',
  'metalico': '#b5b5b5', 'metálico': '#b5b5b5',
  // Inglês
  'red': '#ef4444', 'blue': '#3b82f6', 'green': '#22c55e', 'yellow': '#eab308',
  'purple': '#8b5cf6', 'orange': '#f97316', 'black': '#111111', 'white': '#ffffff',
  'brown': '#92400e', 'gold': '#d4a017', 'silver': '#c0c0c0', 'gray': '#9ca3af',
  'navy': '#1e3a8a', 'beige': '#d2b48c', 'ivory': '#fffff0'
};

const norm = (s) => (s || '').toString()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().trim().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');

const INDEX = {};
Object.entries(RAW_MAP).forEach(([k, v]) => {
  INDEX[norm(k)] = v;
});

export function getColorHex(name) {
  if (!name) return '#9ca3af';
  const n = norm(name);
  if (INDEX[n]) return INDEX[n];
  // tenta achar por prefixo/sufixo (ex: "azul-claro" → "azul")
  const first = n.split(' ')[0];
  if (INDEX[first]) return INDEX[first];
  // cor CSS nativa (funciona em browsers)
  // mas validar quick: só devolve se for uma cor CSS conhecida
  return '#9ca3af'; // fallback cinza padrão
}

export function isGradient(colorValue) {
  return typeof colorValue === 'string' && colorValue.startsWith('linear-gradient');
}
